import { Grid2, Icon, Paper, useTheme } from "@mui/material";
import ModularTabs from "../../views/components/common/tabs/ModularTabs";
import projectDetailsIcon from "../../assets/ri_folder-info-fill.svg";
import sourcingOpsIcon from "../../assets/Sourcing Ops.svg";
import SourcingOps from "../../views/pages/projects/sourcing-ops/SourcingOps";
import ProjectDetails from "./project-details.view";
import inventoryOpsIcon from "../../assets/Inventory Ops.svg";
import packagingOpsIcon from "../../assets/Packaging Ops.svg";
import dispatchOpsIcon from "../../assets/Dispatch Ops.svg";
import InventoryOps from "../../views/pages/projects/inventory-ops/InventoryOps";
import PackagingOps from "../../views/pages/projects/packaging-ops/PackagingOps";
import DispatchOps from "../../views/pages/projects/dispatch-ops/DispatchOps";
// import SourcingOpsDetails from "./sourcing-ops-details/SourcingOpsDetails";

const tabsData = [
  {
    label: "Project Details",
    icon: (
      <Icon>
        <img
          src={projectDetailsIcon}
          alt="Sourcing Ops"
          width={24}
          height={24}
        />
      </Icon>
    ),
    component: <ProjectDetails />,
  },
  {
    label: "Sourcing Ops",
    icon: (
      <Icon>
        <img src={sourcingOpsIcon} alt="Sourcing Ops" width={24} height={24} />
      </Icon>
    ),
    component: <SourcingOps />,
  },
  {
    label: "Inventory Ops",
    icon: (
      <Icon>
        <img src={inventoryOpsIcon} alt="Sourcing Ops" width={24} height={24} />
      </Icon>
    ),
    component: <InventoryOps />,
  },
  {
    label: "Packaging Ops",
    icon: (
      <Icon>
        <img src={packagingOpsIcon} alt="Sourcing Ops" width={24} height={24} />
      </Icon>
    ),
    component: <PackagingOps />,
  },
  {
    label: "Dispatch Ops",
    icon: (
      <Icon>
        <img
          src={dispatchOpsIcon}
          alt="Dispatch Ops"
          width={24}
          height={24}
        />{" "}
      </Icon>
    ),
    component: <DispatchOps />,
  },
];

const ProjectLayout = () => {
  const theme = useTheme();

  return (
    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ p: 2 }}>
      <Paper
        sx={{
          backgroundColor: "transparent",
          borderRadius: 2,
          boxShadow:
            "rgba(0, 0, 0, 0.15) 0px 4px 24px, rgba(0, 0, 0, 0.05) 0px 8px 32px",
        }}
      >
        <ModularTabs tabs={tabsData} />
      </Paper>
    </Grid2>
  );
};

export default ProjectLayout;
